module.exports = __webpack_public_path__ + "img/thumb_09.0cafbf01.jpg";